const fromClasses = [
  'from-red-300 dark:from-red-700',
  'from-orange-300 dark:from-orange-700',
  'from-amber-300 dark:from-amber-700',
  'from-yellow-300 dark:from-yellow-700',
  'from-lime-300 dark:from-lime-700',
  'from-green-300 dark:from-green-700',
  'from-emerald-300 dark:from-emerald-700',
  'from-teal-300 dark:from-teal-700',
  'from-cyan-300 dark:from-cyan-700',
  'from-sky-300 dark:from-sky-700',
  'from-primary-300 dark:from-primary-700',
  'from-indigo-300 dark:from-indigo-700',
  'from-violet-300 dark:from-violet-700',
  'from-purple-300 dark:from-purple-700',
  'from-fuchsia-300 dark:from-fuchsia-700',
  'from-pink-300 dark:from-pink-700',
  'from-rose-300 dark:from-rose-700',
] as const

const toClasses = [
  'to-red-400 dark:to-red-600',
  'to-orange-400 dark:to-orange-600',
  'to-amber-400 dark:to-amber-600',
  'to-yellow-400 dark:to-yellow-600',
  'to-lime-400 dark:to-lime-600',
  'to-green-400 dark:to-green-600',
  'to-emerald-400 dark:to-emerald-600',
  'to-teal-400 dark:to-teal-600',
  'to-cyan-400 dark:to-cyan-600',
  'to-sky-400 dark:to-sky-600',
  'to-primary-400 dark:to-primary-600',
  'to-indigo-400 dark:to-indigo-600',
  'to-violet-400 dark:to-violet-600',
  'to-purple-400 dark:to-purple-600',
  'to-fuchsia-400 dark:to-fuchsia-600',
  'to-pink-400 dark:to-pink-600',
  'to-rose-400 dark:to-rose-600',
] as const

const offsets = [-4, -3, -2, 2, 3, 4] as const

const gradientClasses = fromClasses.flatMap((fromClass, index) => {
  const classesLength = toClasses.length
  return offsets.map((offset) => {
    return `${fromClass} ${toClasses[(classesLength + index + offset) % classesLength]}`
  })
})

export function generateGradient(seed: string) {
  const hash = seed.split('').reduce((acc, char) => {
    return acc + char.charCodeAt(0)
  }, 0)
  const index = hash % gradientClasses.length
  return gradientClasses[index]
}
